import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { MatTableModule } from "@angular/material/table";

import { PriceTabComponent } from "./price-tab.component";
import { BtnModule } from 'libraries/ui_button/btn.module';
import { PricePipesModule } from 'libraries/pipes/price/price-pipes.module';
import { SectorAirSummaryModule } from '../../../sectors/components/sectors-air/sector-air-summary/sector-air-summary.module';
import { MultiselectModule } from "libraries/module/formbuilder/fields/multiselect/multiselect.module";
import { TableSectorAirSummaryModule } from '../shared/components/table-sector-air-summary/table-sector-air-summary.module';
import { TableSectorStaySummaryModule } from '../shared/components/table-sector-stay-summary/table-sector-stay-summary.module';
import { PriceTableModule } from '../shared/components/price-table/price-table.module';

@NgModule({
    imports: [
        CommonModule,
        MatTableModule,
        BtnModule,
        PricePipesModule,
        PriceTableModule,
        SectorAirSummaryModule,
        MultiselectModule,
        TableSectorAirSummaryModule,
        TableSectorStaySummaryModule,
    ],
    exports: [
        PriceTabComponent,
    ],
    declarations: [
        PriceTabComponent,
    ],
    providers: [],
})
export class PriceTabModule {}
